import { IconButton } from '@chakra-ui/react'
import { FC } from 'react'
import { BsChevronUp, BsChevronDown } from 'react-icons/bs'

import useLayout from '@hook/shared/use-layout'

const LayoutHeaderToggler: FC = () => {
  const { menuToggle, setMenuToggle } = useLayout()

  return (
    <IconButton
      ml={4}
      size="sm"
      aria-label="Header toggle"
      bg="white"
      border="solid 1px"
      borderColor="gray.200"
      icon={!menuToggle ? <BsChevronUp /> : <BsChevronDown />}
      _hover={{
        bg: 'gray.50',
        borderColor: 'yellow.400'
      }}
      _active={{
        bg: 'gray.50',
        borderColor: 'yellow.400'
      }}
      onClick={setMenuToggle.toggle}
      isRound
    />
  )
}

export default LayoutHeaderToggler
